<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :width="width"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="handleClose"
    :show-close="false"
  >
    <div
      class="dialog-container"
      style="
        background-color: #ffffff;
        border-radius: 12px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
      "
      v-if="type === 1"
    >
      <img src="@/assets/image/new-top.png" class="new-top" />
      <div>
        <div class="dialog-title">恭喜您，获得新人专享幸运红包</div>
        <div class="dialog-tip">新用户首次专享升级会员福利</div>
      </div>
      <div class="quan-box">
        <div class="quan" v-for="(item, index) in normalizedStage1Coupons" :key="`${item.title}-${index}`">
          <div class="price">
            <span>¥</span>
            <span>{{ item.amount }}</span>
          </div>
          <div class="conter">
            <div class="title">{{ item.title }}</div>
            <div class="tip">{{ item.tip }}</div>
          </div>
        </div>
      </div>
      <div style="padding: 20px 0"><button type="button" class="btn" @click="handleClaim">开心收下</button></div>
      <div class="close-btn" @click="handleClose">
        <i style="font-size: 30px; color: #ffffff" class="el-icon-close" />
      </div>
    </div>
    <div class="dialog-container" v-if="type === 2">
      <div class="expansion-red">
        <div class="countdown">{{ stage2Tip }}</div>
        <div class="front-price price">
          <span>¥</span>
          <span>{{ stage1Amount }}</span>
        </div>
        <div class="after-price price">
          <span>¥</span>
          <span>{{ stage2Amount }}</span>
        </div>
        <button type="button" class="claim-hotspot expansion-claim" @click.stop="handleClaim" aria-label="开心收下"></button>
      </div>
      <div class="close-btn" style="bottom: -30px" @click="handleClose">
        <i style="font-size: 30px; color: #ffffff" class="el-icon-close" />
      </div>
    </div>
    <div class="dialog-container" v-if="type === 3">
      <div class="new-red">
        <div>
          <div class="title">{{ stage3Title }}</div>
          <div class="price">
            <span>¥</span>
            <span>{{ stage3Amount }}</span>
            <span>元</span>
          </div>
          <div class="new-red-countdown">{{ countdownLabel }} 优惠失效</div>
        </div>
        <button type="button" class="claim-hotspot new-red-claim" @click.stop="handleClaim" aria-label="开心收下"></button>
      </div>
      <div class="close-btn" style="bottom: -30px" @click="handleClose">
        <i style="font-size: 30px; color: #ffffff" class="el-icon-close" />
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "new-dialog",
  props: {
    visible: { type: Boolean, default: false },
    type: { type: Number, default: 1 }, // 1 2 3
    stage1Amount: { type: [String, Number], default: 20 },
    stage2Amount: { type: [String, Number], default: 20 },
    stage3Amount: { type: [String, Number], default: 200 },
    stage1Coupons: { type: Array, default: () => [] },
    stage2Tip: { type: String, default: "领取后可用于会员套餐自动抵扣" },
    stage3Title: { type: String, default: "红包膨胀券" },
    countdownLabel: { type: String, default: "00:00:00" },
    // 1 新人专享红包
    // 2 新人随机红包
    // 3.新人红包膨胀
  },
  data() {
    return { claiming: false };
  },
  computed: {
    width() {
      const widthList = ["390px", "517px", "530px"];
      return widthList[this.type - 1];
    },
    normalizedStage1Coupons() {
      if (Array.isArray(this.stage1Coupons) && this.stage1Coupons.length > 0) {
        return this.stage1Coupons.slice(0, 5).map((item, index) => ({
          amount: item.amount || this.stage1Amount,
          title: item.title || `会员套餐${index + 1}`,
          tip: item.tip || "仅限首次升级，过期作废",
        }));
      }
      return Array.from({ length: 5 }, (_, index) => ({
        amount: this.stage1Amount,
        title: index === 0 ? "月费会员" : `会员套餐${index + 1}`,
        tip: "仅限首次升级，过期作废",
      }));
    },
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(v) {
        this.$emit("update:visible", v);
      },
    },
  },

  watch: {
    visible(value) {
      if (value) this.claiming = false;
    },
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
    },
    handleClaim() {
      if (!this.visible || this.claiming) return;
      this.claiming = true;
      this.dialogVisible = false;
      this.$emit("claim", this.type);
    },
  },
};
</script>

<style lang="scss" scoped>
/* 隐藏原生头部 */
::v-deep .el-dialog__header {
  display: none !important;
}
::v-deep .el-dialog {
  border-radius: 12px !important;
  background: transparent;
  box-shadow: none;
}
::v-deep .el-dialog__body {
  padding: 0 !important;
}

.new-top {
  width: 430px;
  height: 134px;
  margin: -83px 0 0 -33px;
}
.dialog-title {
  font-size: 18px;
  line-height: 26px;
  letter-spacing: 0px;
  color: #d04626;
  text-align: center;
}
.dialog-tip {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  font-weight: normal;
  letter-spacing: 0px;
  color: #999999;
  text-align: center;
}
.quan-box {
  width: 300px;
  margin: 0 auto;
  .conter {
    margin-left: 20px;
    .title {
      font-size: 14px;
      color: #333333;
    }
    .tip {
      font-size: 14px;
      color: #999999;
      margin-top: 9px;
    }
  }
  .quan {
    margin-top: 16px;
    width: 300px;
    height: 64px;
    border-radius: 12px;
    background-image: url("@/assets/image/new-quan-bg.png");
    display: flex;
    align-items: center;
    .price {
      width: 90px;
      text-align: center;
      font-size: 30px;
      color: #ffffff;
      span:nth-child(1) {
        font-size: 16px;
      }
    }
  }
}
.btn {
  display: block;
  border: 0;
  padding: 0;
  font-family: inherit;
  width: 321px;
  height: 46px;
  background-image: linear-gradient(90deg, #fe7317 0%, #ffc103 100%);
  box-shadow: 0px 8px 13px 0px rgba(239, 112, 0, 0.4);
  border-radius: 23px;
  margin: 0 auto;
  color: #ffffff;
  font-size: 16px;
  line-height: 46px;
  text-align: center;
  cursor: pointer;
}
.dialog-container {
  position: relative;
}
.close-btn {
  position: absolute;
  bottom: -60px;
  right: 50%;
  transform: translateX(50%);
  cursor: pointer;
}
.new-red {
  width: 530px;
  height: 388px;
  background-image: url("@/assets/image/new-red.png");
  padding-top: 166px;
  position: relative;
  .title {
    text-align: center;
    font-size: 16px;
    color: #36251a;
  }
  .price {
    text-align: center;
    font-size: 24px;
    line-height: 80px;
    letter-spacing: 0px;
    color: #d31400;
    font-weight: 600;
    span:nth-child(2) {
      font-size: 48px;
    }
    span:nth-child(3) {
      display: inline-block;
      margin-left: 10px;
    }
  }
  .new-red-countdown {
    margin-top: -8px;
    text-align: center;
    font-size: 14px;
    line-height: 20px;
    color: #bc511c;
    font-weight: 500;
  }
}
.expansion-red {
  width: 517px;
  height: 556px;
  background-image: url("@/assets/image/expansion-red.png");
  position: relative;
  .countdown {
    position: absolute;
    bottom: 41px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 16px;
    color: #bc511c;
    font-weight: 500;
  }
  .price {
    font-size: 16px;
    color: #da0000;
    font-weight: 600;
    position: absolute;
    span:nth-child(2) {
      font-size: 30px;
      margin-left: 4px;
      font-weight: 700;
    }
  }
  .front-price {
    top: 266px;
    left: 135px;
    width: 82px;
    text-align: center;
  }
  .after-price {
    top: 228px;
    left: 256px;
    width: 100px;
    text-align: center;
  }
}
.claim-hotspot {
  position: absolute;
  border: 0;
  padding: 0;
  background: transparent;
  cursor: pointer;
}
.new-red-claim {
  left: 129px;
  bottom: 47px;
  width: 272px;
  height: 49px;
  border-radius: 25px;
}
.expansion-claim {
  left: 85px;
  bottom: 90px;
  width: 344px;
  height: 52px;
  border-radius: 26px;
}
</style>
